// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./common"
import Vue from 'vue'
import App from '@/App'
import router from '@/router/checkout'
import store from "@/store/checkout"
import cbClient from "@/utils/cb-client"
import { checkoutFormLogger } from "@/utils/form-logger/CheckoutFormLogger"
import { EventBus } from '@/utils/event-bus'
import currencyFilter, {mdCurrencyFilter} from "@/filters/currency";
import escapeStringRegex from 'escape-string-regexp';
import patchRouter from '@/router-monkey-patch';
import { trackConversionReferralCandy, deepGet, getHostFromUrl } from "@/utils/helper-functions";
import LogTracker from '@/utils/log-helper';

window.cbjsLoader.then(() => {
  Chargebee.getInstance().setReferrerModule("checkout_v3")
})

if(window.top != window) {
  patchRouter(router);
}

if (window.self == window.top) {
    window.addClass(window.document.body, "cb-fullpage");
} else {
    window.document.body.style.background = "none";
}

cbClient.syncWithStore(store)
if(window.hpConfig) {
  checkoutFormLogger.start(store, window.hpConfig.hp_log_holder);
}
store.dispatch("init_auth");

/* eslint-disable no-new */

var calculateGA = function(route) {
    if (route.meta.gaKey) {
        if (typeof route.meta.gaKey == "function") {
            return route.meta.gaKey(route);
        } else {
            return route.meta.gaKey;
        }
    }
}

router.customPush = (options) => {
  router.push(options);
}

router.beforeEach((to, from, next) => {
    if(to.query.hp_opener == "chargebee") {
        window.isOpenedByCb = true;
    }
    if(to.query.hp_referrer) {
      window.cbReferrer = to.query.hp_referrer;
    }
    var el = document.getElementsByClassName("cb-body__wrap")[0];
    el && window.addClass(el, "cb-body__wrap--animate");
    document.body.$scrollTop = document.documentElement ? document.documentElement.scrollTop : 0;
    document.documentElement.scrollTop = 0;
    next();
})

router.afterEach((to, from) => {
    new LogTracker(store.getters, store.dispatch)
    .logUserNavigation(from, to);
    let gaKey = calculateGA(to);
    if (gaKey) {
        window.cbPostMessage({ key: "cb.page_visited", value: gaKey, type: 'checkout' });
    }
})


var filterDataToBePassed = function(data) {
  // add data whichever is needed
  // EBE MERGE INVOICE BRANCH AND VERIFY quantity_in_decimal and unit_amount_in_decimal, 
  // comes in invoice object of create subscription.
  let output = {}
  if(data.invoice) {
    let lineItems = [];
    data.invoice.line_items.forEach(lineItem => {
      lineItems = lineItems.concat({
        "entity_id": lineItem.entity_id,
        "entity_type": lineItem.entity_type,
        // "unit_amount": lineItem.unit_amount,
        "unit_amount": currencyFilter(lineItem.unit_amount, data.invoice.currency_code, false, true, true),
        "unit_amount_in_decimal": mdCurrencyFilter(lineItem.unit_amount, data.invoice.currency_code, false, true, true),
        "quantity": lineItem.quantity,
        "quantity_in_decimal": lineItem.quantityInDecimal
      });
    });
    let invoiceData = {
      "id": data.invoice.id,
      "total": data.invoice.total,
      "tax": currencyFilter(data.invoice.tax, data.invoice.currency_code, false, true, true),
      "currency_code": data.invoice.currency_code,
      "formatted_total": currencyFilter(data.invoice.total, data.invoice.currency_code, false, true, true),
      "line_items": lineItems
    }
    output.invoice = invoiceData;
  }
  if(!store.getters.is_checkout_one_time) {
    let subData = {
      "id": data.subscription.id,
      "customer_id": data.subscription.customer_id,
      "status": data.subscription.status,
      "plan_id": data.subscription.plan_id,
      "currency_code": data.subscription.currency_code
    }
    output.subscription = subData;
  }

  if(data.extra_info && data.extra_info.campaign_details && data.extra_info.campaign_details.referral_system == "friendbuy") {
    let cd = data.extra_info.campaign_details;
    let friendbuyData = {
      app_id: cd.app_id,
      widget_id: cd.show_post_widget && cd.widget_id,
      data: {
        customer: {
          id: data.customer.id,
          email: data.customer.email,
          first_name: data.customer.first_name,
          last_name: data.customer.last_name
        }
      }
    };
    if(!store.getters.is_checkout_one_time) {
      friendbuyData.data.subscription = {
          id: data.subscription.id
      }
    }
    if(data.invoice && data.invoice.total) {
      friendbuyData.data.invoice = {
        amount: currencyFilter(data.invoice.total, data.invoice.currency_code, false, true, true)
      }
    }
    if(!store.getters.is_checkout_one_time && data.subscription && data.subscription.coupons && data.subscription.coupons[0]) {
      let couponCode = data.subscription.coupons[0].coupon_code;
      friendbuyData.data.coupon_code = couponCode;
    }
    output.friendbuy = friendbuyData;
  }


  return output;
}

var passMessage = function(data) {
  let message = {
    key: "cb.success",
    value: store.state.auth.hpToken,
    customerId: deepGet(data, 'customer.id') || deepGet(data, 'subscription.customer_id'),
  }

  let referrerDomain = store.getters.referer_allowed_domain;
  let redirectUrl = data.extra_info && data.extra_info.redirect_url;
  let isPreview = window.initInfo.is_preview;
  filterDataToBePassed(data);
  if(referrerDomain) {
    message.redirectUrl = !isPreview && redirectUrl;
    message.data = filterDataToBePassed(data);
  }

  window.cbPostMessage(message, referrerDomain);
  if(window.isOpenedByCb && redirectUrl && window.isMobile) {
    window.cbPostMessage("cb.close");
  }
}

var skipMessageMassingAndRedirect = function(data) {
  let allowedDomains = store.state.config.allowed_domains;
  let redirectUrl = data.extra_info && data.extra_info.redirect_url;
  if(window.isOpenedByCb) {
    if(redirectUrl && allowedDomains.length == 0) {
      logger.kvl({
        redirectUrl: getHostFromUrl(redirectUrl),
        module: "checkout_v3",
        window_url: window.location.href,
        customerId: deepGet(data, "subscription.customer_id"),
      })
      if(window.isMobile) {
        window.location.replace(redirectUrl);
      }
      else {
        window.top.location.replace(redirectUrl);
      }
      return true;
    }
  }
  else {
    if(redirectUrl) {
      logger.kvl({
        redirectUrl: getHostFromUrl(redirectUrl),
        module: "checkout_v3",
        window_url: window.location.href,
        customerId: deepGet(data, "subscription.customer_id"),
      })
      window.top.location.replace(redirectUrl);
      return true;
    }
  }
  return false;
}

EventBus.$on('checkout_submitted', data => {
  EventBus.$emit('hp_log', {action:'checkout_submitted'});
  store.dispatch('log_has_pushed', true);
  if(data) {

    let campaignInfo = data.extra_info && data.extra_info.campaign_details;
    if(campaignInfo) {
      store.dispatch('set_campaign_details', campaignInfo);
      trackConversionReferralCandy(data.extra_info);
    }
    if(!data.skip_redirection) {
      let redirected = skipMessageMassingAndRedirect(data);
      if(redirected) {
        return;
      }
      passMessage(data);
    }
  }
});

new Vue({
    router: router,
    store: store,
    render: h => h(App)
}).$mount("#app");
